import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut, apiPost1,apiPut1 } from '../utils/axios';

const ADD_MEMBERSHIP = SERVER_URI + '/memberships';
const GET_MEMBERSHIP = SERVER_URI + '/get-memberships';
const CHANGE_MEMBERSHIP_STATUS = SERVER_URI + '/membership-status/';
const UPDATE_MEMBERSHIP_STATUS = SERVER_URI + '/memberships/';

export default {

  addMemberShip: async function (paylaod) {
    return apiPost1(ADD_MEMBERSHIP, paylaod);
  },
  getMemberShip: async function (paylaod) {
    return apiPost(GET_MEMBERSHIP, paylaod);
  },
  changeMemberShipStatus: async function (id) {
    return apiGet(CHANGE_MEMBERSHIP_STATUS + id);

  },
  updateMemberShipStatus: async function (id, payload) {
    return apiPut1(UPDATE_MEMBERSHIP_STATUS + id, payload)
  }

};